<section class="beta-feedback-main">
  <div>
    <h4>Feedback</h4>
  </div>
  <form #betaForm="ngForm">
    <div class="p-grid">
      <div class="p-col-12 p-md-3 p-lg-3">
        <label> Category*</label>
      </div>
      <div class="p-col-12 p-md-9 p-lg-9">
        <p-dropdown [options]="categoryDropdown" placeholder="Select..." [(ngModel)]="category" id="category" name="category" required (onChange)="onCategorySelect(category)" [filter]="true">
        </p-dropdown>
      </div>
        <div class="p-col-12 p-md-3 p-lg-3" *ngIf="category">
          <label>Subject*</label>
        </div>
        <div class="p-col-12 p-md-9 p-lg-9" *ngIf="category">
          <p-dropdown class="p-col-12 p-md-8 p-lg-8" [options]="subjectDropdown" placeholder="Select..." [(ngModel)]="subject.id" id="subject" name="subject" required
            (onChange)="onSubjectSelected(subject, category)" [filter]="true"></p-dropdown>
          <button class="p-col-12 p-md-2 p-lg-2" pButton type="button" class="icon-action" icon="fa fa-plus" (click)="showAddSubject()" pTooltip="Add Subject"></button>
      </div>

        <div *ngIf="feedbackPost" class="p-col-12 p-md-3 p-lg-3">
          <label>Post*</label></div>
        <div class="p-col-12 p-md-9 p-lg-9">
          <textarea pInputTextarea [(ngModel)]="feedbackPost.post" [rows]="5" [cols]="40" maxlength="200" style="height:75px !important;" name="postText" id="postText"
            placeholder="Enter your text here" required> </textarea>
        </div>
      </div>

    <div *ngIf="feedbackPost" class="p-col-12" style="border: 1px solid #ccc;overflow-y:auto;">

      <h5>Post History</h5>
      <div style="height: 150px; width:100%;">
        <ul id="unstyled" style="margin:0;padding:0;">
          <li *ngFor="let post of feedbackPosts">
            <span align="left"> {{post.userFullName}}</span>
            <span align="right">{{post.createdOn | date:Format.Time}}</span>
            <br>
            <textarea pInputTextarea [readonly]="true" [rows]="5" [cols]="40" style="height:75px !important;width:100%;margin-bottom:20px;" name="message" id="message"> {{post.post}} </textarea>
          </li>
        </ul>
      </div>

    </div>
    <div class="p-col-12">
      <div align="right" style="margin: 20px 0px 10px 10px">
        <button type="button" class="button-action" (click)="savePost(feedbackPost,subject)" label="Save Post" [disabled]="!betaForm.form.valid">
          <i class="fa fa-check"></i> Save</button>
      </div>
    </div>

  </form>

  <!-- dialog for adding subject -->
  <p-dialog [(visible)]="subjectDialog" *ngIf="feedbackSubject" [responsive]="true" showEffect="fade" [dismissableMask]="true" [style]="DialogStyle40">
    <form #subjectForm="ngForm">

      <div class="p-col-12">
        <div class="p-col-12">
          <label style="margin-right:5px;">Subject Name*</label>
          <input type="text" pInputText [(ngModel)]="feedbackSubject.subject" name="newSubject" style="width:100%;" />
        </div>
      </div>
      <div class="p-col-12">
        <div align="right" style="margin: 20px 0px 10px 10px">
          <button type="button" class="button-inaction" (click)="subjectDialog = false" label="Cancel" style="margin-right:10px;">
            <i class="fa fa-close"></i> Cancel</button>
          <button type="button" class="button-action" (click)="saveSubject(feedbackSubject,category)" label="Save" [disabled]="!subjectForm.form.valid">
            <i class="fa fa-check"></i> Save</button>
        </div>
      </div>
    </form>
  </p-dialog>
  <div style="clear:both;"></div>
</section>
